import { RemoteData } from './remote-data.model';

export class ServerData<TModel> extends RemoteData {
    public data: TModel | undefined;
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/common/ng-api/server-data.model.ts